import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from "react-router-dom";

import mindfreeLogo from '../assets/images/login_Logo.svg';
import { variables } from '../Variables';

export const MindFreeUnsubscribeMindral = () => {
    const { language } = useParams();

    const [selectedLanguageTranslations, setSelectedLanguageTranslations] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const getLanguageTranslations = async () => {
        setIsLoading(true);
        try {
            const url = variables.API_URL + `Settings/GetTranslationsForSiteByLang?siteName=agent`;

            const jsonconfig = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            if (response.data) {
                let translations = response.data;
                if (Object.keys(translations).length > 0) {
                    let agentTranslation = translations[language || "en-GB"];
                    setSelectedLanguageTranslations(agentTranslation);
                    setIsLoading(false);
                }
            }
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    }

    const closePage = () => { 
        window.close();
    }

    useEffect(() => {
        setIsLoading(true);
        getLanguageTranslations();
    },[])


    return (
        <>
            <div className="d-flex flex-column align-items-center justify-content-center px-5" style={{ height: "100vh" }}>
                {
                    isLoading ?
                        <>
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </>
                        :
                        <>
                            <img src={mindfreeLogo} className="mb-4" alt="mindfree logo" />
                            <h6 className="mb-3">{selectedLanguageTranslations != null ? selectedLanguageTranslations["automatedEmailsCannotBeDisabled"] : "These automated emails keep our app running smoothly for you, which is why they can't be turned off. If you think you're receiving these by mistake, please get in touch with us!"}</h6>
                            <button className="site-btn-padd close-page-btn px-5" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                        </>
                }
            </div>
        </>
    )
}
